import React from 'react';
import Button from '../../components/button/button.jsx';
import Youtube from '../../components/youtube/youtube.jsx';
import './header.scss'


class Header extends React.Component {

	constructor(props){
		super(props);

		this.availableStates = ['hero', 'video', 'banner'];
		this.initialState = 'hero';
		this.copy = props.data.copy;
		this.masthead = props.data.masthead;
		this.video = props.data.video;

		this.state = {
			mode: this.initialState
		};
	}

	componentDidMount(){
		// escape key listener for video
		document.onkeydown = evt => {
			if ("key" in evt && ['escape', 'esc'].indexOf(evt.key.toLowerCase()) !== -1 && this.state.mode === 'video') this.minimize()
		};

		// listeners
		window.addEventListener('Header.Video.Play', () => this.openVideo(), false);
		window.addEventListener('Youtube.Ended', () => this.minimize(), false);

		window.addEventListener('Component.Header.Minimize', () => this.minimize(), false);
		window.addEventListener('Component.Header.OpenVideo', () => this.openVideo(), false);

		
		// set initial mode
		this.changeMode(this.initialState);
	}

	render(){
	
		return 	<header className="component header" data-mode={this.state.mode} data-videoid="{data.video.id}">
		
					<div className="masthead">
						<div className="inner">
							<div>
								<h1>
									<a href={this.masthead.title.href}>
										{this.masthead.title.text}
									</a>
								</h1>
							</div>
						</div>
					</div>

					<div className="copy">
						<div className="inner">
							<img className="logo" src={this.copy.logo} alt={this.copy.title}/>
							<h2 className="title">{this.copy.title}</h2>
							<h3 className="tagline" style={{'backgroundImage' : 'url(' + this.copy.tagline.image + ')'}}>
								{this.copy.tagline.text}
							</h3>

							{this.copy.buttons.map((button, i) => {
								return 	<Button key={i} icon={button.icon} text={button.text} className={button.class} clickEvent={button.clickEvent}/>;
							})}

							<Button icon="close" className="close" clickEvent={'Component.Header.Minimize'} handleClick={() => this.minimize()}/>
						</div>
					</div>

					<div className="video">
						
						<div className="ytvideo" style={this.videoSize()}>
							<Button icon="close" className="close" clickEvent={'Component.Header.Minimize'}  handleClick={() => this.minimize()}/>
							<Youtube id={this.video.id} cover={this.video.image}/>
						</div>
					</div>

				</header>
	}

	openVideo(){
		this.changeMode('video');
		this.fireEvent("Youtube.Play", { id : this.video.id})
	}
	
	minimize(){
		this.fireEvent("Youtube.Stop", { id : this.video.id})
		this.changeMode('banner');
	}

	videoSize(){
		var width = window.innerWidth;
		var height = window.innerHeight;

		if(this.state.mode === 'video') {
			width = window.innerWidth - 40 > 980 ? 980 : window.innerWidth - 40;
			height = width * 0.5625;
		}

		return {
			width : width,
			height: height
		}
	}

	fireEvent(event, detail){
		window.dispatchEvent(new CustomEvent(event, {detail: detail}));
	}

	changeMode(mode){
		// mode based events
		switch (mode) {
			case 'hero':
			case 'video':
				// stop scrolling
				window.dispatchEvent(new CustomEvent("Window.Scroll.Disabled", {
					detail: { 
						callback : function(){ 
							document.body.setAttribute('data-padded', true);
							window.setTimeout(function(){ window.scrollTo(0, 0) }, 500)
						}
					}
				}));
				break;
			case 'banner':
				// start scrolling
				window.dispatchEvent(new CustomEvent("Window.Scroll.Enabled", {
					detail: { 
						callback : function(){
							document.body.setAttribute('data-padded', false);
							window.scrollTo(0, 0) 
						}
					}
				}));
				break;
			default:
				break;
		}

		this.setState({mode : mode});
	}

}

export default Header;


// WEBPACK FOOTER //
// ./src/blocks/header/header.jsx